var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPvDispersionRateConfigFlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "592px",
    height: "1116px",
    viewBox: "0 0 592 1116",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u6D41\u7A0B\u56FE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u79BB\\u6563\\u7387\\u8BBE\\u7F6E",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "922-\\u79BB\\u6563\\u7387\\u8BBE\\u7F6E-\\u9608\\u503C\\u8BBE\\u7F6E-\\u5149\\u4F0F\\u7AD9",
    transform: "translate(-79.000000, -1533.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-13",
    transform: "translate(55.000000, 1453.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6D41\\u7A0B\\u56FE",
    transform: "translate(24.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-7",
    d: "M536.999754,86.9997536 L537,87.4997536 L537.5,1101.99975 L537.500247,1102.50083 L536.999168,1102.5 L244.999,1102.014 L244.992501,1106.01414 L236.000001,1101.49917 L245.007476,1097.01415 L245,1101.014 L536.5,1101.499 L536,87.5002464 L535.999754,87.0002465 L536.999754,86.9997536 Z",
    fillOpacity: 0.45,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-9",
    transform: "translate(336.000000, 74.000000)",
    fill: "#E64242"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-24",
    strokeOpacity: 0.5,
    stroke: "#E64242",
    fillOpacity: 0.1,
    x: 0.5,
    y: 0.5,
    width: 119,
    height: 27,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-8",
    transform: "translate(46.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\u5DEE\\u5907\\u4EFD",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 16,
    y: 13
  }, "\u5DEE")), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-25",
    x: 0,
    y: 4,
    width: 12,
    height: 12
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-9\\u5907\\u4EFD",
    transform: "translate(336.000000, 162.000000)",
    fill: "#E64242"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-24",
    strokeOpacity: 0.5,
    stroke: "#E64242",
    fillOpacity: 0.1,
    x: 0.5,
    y: 0.5,
    width: 119,
    height: 27,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-8",
    transform: "translate(46.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\u5DEE\\u5907\\u4EFD",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 16,
    y: 13
  }, "\u5DEE")), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-25",
    x: 0,
    y: 4,
    width: 12,
    height: 12
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-9\\u5907\\u4EFD-2",
    transform: "translate(336.000000, 250.000000)",
    fill: "#E64242"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-24",
    strokeOpacity: 0.5,
    stroke: "#E64242",
    fillOpacity: 0.1,
    x: 0.5,
    y: 0.5,
    width: 119,
    height: 27,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-8",
    transform: "translate(46.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\u5DEE\\u5907\\u4EFD",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 16,
    y: 13
  }, "\u5DEE")), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-25",
    x: 0,
    y: 4,
    width: 12,
    height: 12
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-9\\u5907\\u4EFD-3",
    transform: "translate(336.000000, 338.000000)",
    fill: "#FAAD14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-24",
    strokeOpacity: 0.5,
    stroke: "#FAAD14",
    fillOpacity: 0.1,
    x: 0.5,
    y: 0.5,
    width: 119,
    height: 27,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-8",
    transform: "translate(40.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\u8F83\\u5DEE",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 16,
    y: 13
  }, "\u8F83\u5DEE")), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-25",
    x: 0,
    y: 4,
    width: 12,
    height: 12
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-9\\u5907\\u4EFD-4",
    transform: "translate(336.000000, 426.000000)",
    fill: "#FAAD14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-24",
    strokeOpacity: 0.5,
    stroke: "#FAAD14",
    fillOpacity: 0.1,
    x: 0.5,
    y: 0.5,
    width: 119,
    height: 27,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-8",
    transform: "translate(40.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\u8F83\\u5DEE",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 16,
    y: 13
  }, "\u8F83\u5DEE")), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-25",
    x: 0,
    y: 4,
    width: 12,
    height: 12
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-9\\u5907\\u4EFD-5",
    transform: "translate(336.000000, 514.000000)",
    fill: "#FAAD14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-24",
    strokeOpacity: 0.5,
    stroke: "#FAAD14",
    fillOpacity: 0.1,
    x: 0.5,
    y: 0.5,
    width: 119,
    height: 27,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-8",
    transform: "translate(40.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\u8F83\\u5DEE",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 16,
    y: 13
  }, "\u8F83\u5DEE")), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-25",
    x: 0,
    y: 4,
    width: 12,
    height: 12
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 592,
    height: 1116
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-9\\u5907\\u4EFD-6",
    transform: "translate(336.000000, 602.000000)",
    fill: "#4A90E2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-24",
    strokeOpacity: 0.5,
    stroke: "#4A90E2",
    fillOpacity: 0.1,
    x: 0.5,
    y: 0.5,
    width: 119,
    height: 27,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-8",
    transform: "translate(40.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\u4E00\\u822C",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 16,
    y: 13
  }, "\u4E00\u822C")), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-25",
    x: 0,
    y: 4,
    width: 12,
    height: 12
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-9\\u5907\\u4EFD-7",
    transform: "translate(336.000000, 690.000000)",
    fill: "#4A90E2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-24",
    strokeOpacity: 0.5,
    stroke: "#4A90E2",
    fillOpacity: 0.1,
    x: 0.5,
    y: 0.5,
    width: 119,
    height: 27,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-8",
    transform: "translate(40.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\u4E00\\u822C",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 16,
    y: 13
  }, "\u4E00\u822C")), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-25",
    x: 0,
    y: 4,
    width: 12,
    height: 12
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-9\\u5907\\u4EFD-8",
    transform: "translate(336.000000, 778.000000)",
    fill: "#4A90E2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-24",
    strokeOpacity: 0.5,
    stroke: "#4A90E2",
    fillOpacity: 0.1,
    x: 0.5,
    y: 0.5,
    width: 119,
    height: 27,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-8",
    transform: "translate(40.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\u4E00\\u822C",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 16,
    y: 13
  }, "\u4E00\u822C")), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-25",
    x: 0,
    y: 4,
    width: 12,
    height: 12
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-9\\u5907\\u4EFD-9",
    transform: "translate(336.000000, 866.000000)",
    fill: "#ABD335"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-24",
    strokeOpacity: 0.5,
    stroke: "#ABD335",
    fillOpacity: 0.1,
    x: 0.5,
    y: 0.5,
    width: 119,
    height: 27,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-8",
    transform: "translate(40.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\u826F\\u597D",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 16,
    y: 13
  }, "\u826F\u597D")), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-25",
    x: 0,
    y: 4,
    width: 12,
    height: 12
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-9\\u5907\\u4EFD-10",
    transform: "translate(336.000000, 954.000000)",
    fill: "#ABD335"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-24",
    strokeOpacity: 0.5,
    stroke: "#ABD335",
    fillOpacity: 0.1,
    x: 0.5,
    y: 0.5,
    width: 119,
    height: 27,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-8",
    transform: "translate(40.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\u826F\\u597D",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 16,
    y: 13
  }, "\u826F\u597D")), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-25",
    x: 0,
    y: 4,
    width: 12,
    height: 12
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-9\\u5907\\u4EFD-12",
    transform: "translate(116.000000, 1028.000000)",
    fill: "#16DD8E"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-24",
    strokeOpacity: 0.5,
    stroke: "#16DD8E",
    fillOpacity: 0.1,
    x: 0.5,
    y: 0.5,
    width: 119,
    height: 27,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-8",
    transform: "translate(40.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\u4F18\\u79C0",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 16,
    y: 13
  }, "\u4F18\u79C0")), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-25",
    x: 0,
    y: 4,
    width: 12,
    height: 12
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-12",
    transform: "translate(116.000000, 0.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    strokeOpacity: 0.2,
    stroke: "#FFFFFF",
    fillOpacity: 0.05,
    x: 0.5,
    y: 0.5,
    width: 119,
    height: 27,
    rx: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\u5F00\\u59CB",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20,
    fillOpacity: 0.85
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 48,
    y: 17
  }, "\u5F00\u59CB"))), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-12\\u5907\\u4EFD",
    transform: "translate(116.000000, 1088.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    strokeOpacity: 0.2,
    stroke: "#FFFFFF",
    fillOpacity: 0.05,
    x: 0.5,
    y: 0.5,
    width: 119,
    height: 27,
    rx: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\u7ED3\\u675F",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20,
    fillOpacity: 0.85
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 48,
    y: 17
  }, "\u7ED3\u675F"))), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-7",
    transform: "translate(96.000000, 60.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80,0.529740503 L158.486456,28 L80,55.4702595 L1.51354429,28 L80,0.529740503 Z",
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-23",
    strokeOpacity: 0.2,
    stroke: "#FFFFFF",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\u5F02\\u5E38\\u5360\\u6BD4\\uFF1E10%",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20,
    fillOpacity: 0.85
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 38,
    y: 31
  }, "\u5F02\u5E38\u5360\u6BD4\uFF1E10%"))), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-7\\u5907\\u4EFD",
    transform: "translate(96.000000, 148.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80,0.529740503 L158.486456,28 L80,55.4702595 L1.51354429,28 L80,0.529740503 Z",
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-23",
    strokeOpacity: 0.2,
    stroke: "#FFFFFF",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\u8F83\\u5DEE\\u5360\\u6BD4\\uFF1E50%",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20,
    fillOpacity: 0.85
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 37,
    y: 31
  }, "\u8F83\u5DEE\u5360\u6BD4\uFF1E50%"))), /*#__PURE__*/React.createElement("text", {
    id: "No",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20,
    fill: "#E64242"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 152,
    y: 134
  }, "No")), /*#__PURE__*/React.createElement("path", {
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD",
    d: "M177,114.5 L177,138.5 L181,138.5 L176.5,147.5 L172,138.5 L176,138.5 L176,114.5 L177,114.5 Z",
    fillOpacity: 0.45,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-7\\u5907\\u4EFD",
    transform: "translate(96.000000, 236.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80,0.529740503 L158.486456,28 L80,55.4702595 L1.51354429,28 L80,0.529740503 Z",
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-23",
    strokeOpacity: 0.2,
    stroke: "#FFFFFF",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\u4E00\\u822C\\u5360\\u6BD4\\uFF1E90%",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20,
    fillOpacity: 0.85
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 37,
    y: 31
  }, "\u4E00\u822C\u5360\u6BD4\uFF1E90%"))), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-11\\u5907\\u4EFD-8",
    transform: "translate(152.000000, 996.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "No\\u5907\\u4EFD",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20,
    fill: "#E64242"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 19
  }, "No")), /*#__PURE__*/React.createElement("path", {
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-9",
    d: "M25,-0.5 L25,23.5 L29,23.5 L24.5,32.5 L20,23.5 L24,23.5 L24,-0.5 L25,-0.5 Z",
    fillOpacity: 0.45,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-20",
    d: "M25,59.5 L25,83.5 L29,83.5 L24.5,92.5 L20,83.5 L24,83.5 L24,59.5 L25,59.5 Z",
    fillOpacity: 0.45,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-11\\u5907\\u4EFD-7",
    transform: "translate(96.000000, 908.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-7\\u5907\\u4EFD-28",
    transform: "translate(0.000000, 32.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80,0.529740503 L158.486456,28 L80,55.4702595 L1.51354429,28 L80,0.529740503 Z",
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-23",
    strokeOpacity: 0.2,
    stroke: "#FFFFFF",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("text", {
    id: "30%\\u2265\\u4E00\\u822C\\u5360\\u6BD4\\uFF1E10%",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20,
    fillOpacity: 0.85
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 20,
    y: 31
  }, "30%\u2265\u4E00\u822C\u5360\u6BD4\uFF1E10%"))), /*#__PURE__*/React.createElement("text", {
    id: "No\\u5907\\u4EFD",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20,
    fill: "#E64242"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 56,
    y: 19
  }, "No")), /*#__PURE__*/React.createElement("path", {
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-9",
    d: "M81,-0.5 L81,23.5 L85,23.5 L80.5,32.5 L76,23.5 L80,23.5 L80,-0.5 L81,-0.5 Z",
    fillOpacity: 0.45,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-11\\u5907\\u4EFD-6",
    transform: "translate(96.000000, 820.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-7\\u5907\\u4EFD-28",
    transform: "translate(0.000000, 32.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80,0.529740503 L158.486456,28 L80,55.4702595 L1.51354429,28 L80,0.529740503 Z",
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-23",
    strokeOpacity: 0.2,
    stroke: "#FFFFFF",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("text", {
    id: "5%\\u2265\\u8F83\\u5DEE\\u5360\\u6BD4\\uFF1E0%",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20,
    fillOpacity: 0.85
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 26,
    y: 31
  }, "5%\u2265\u8F83\u5DEE\u5360\u6BD4\uFF1E0%"))), /*#__PURE__*/React.createElement("text", {
    id: "No\\u5907\\u4EFD",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20,
    fill: "#E64242"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 56,
    y: 19
  }, "No")), /*#__PURE__*/React.createElement("path", {
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-9",
    d: "M81,-0.5 L81,23.5 L85,23.5 L80.5,32.5 L76,23.5 L80,23.5 L80,-0.5 L81,-0.5 Z",
    fillOpacity: 0.45,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-11\\u5907\\u4EFD-5",
    transform: "translate(96.000000, 732.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-7\\u5907\\u4EFD-28",
    transform: "translate(0.000000, 32.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80,0.529740503 L158.486456,28 L80,55.4702595 L1.51354429,28 L80,0.529740503 Z",
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-23",
    strokeOpacity: 0.2,
    stroke: "#FFFFFF",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("text", {
    id: "70%\\u2265\\u4E00\\u822C\\u5360\\u6BD4\\uFF1E30%",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20,
    fillOpacity: 0.85
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 20,
    y: 31
  }, "70%\u2265\u4E00\u822C\u5360\u6BD4\uFF1E30%"))), /*#__PURE__*/React.createElement("text", {
    id: "No\\u5907\\u4EFD",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20,
    fill: "#E64242"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 56,
    y: 19
  }, "No")), /*#__PURE__*/React.createElement("path", {
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-9",
    d: "M81,-0.5 L81,23.5 L85,23.5 L80.5,32.5 L76,23.5 L80,23.5 L80,-0.5 L81,-0.5 Z",
    fillOpacity: 0.45,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-11\\u5907\\u4EFD-4",
    transform: "translate(96.000000, 644.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-7\\u5907\\u4EFD-28",
    transform: "translate(0.000000, 32.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80,0.529740503 L158.486456,28 L80,55.4702595 L1.51354429,28 L80,0.529740503 Z",
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-23",
    strokeOpacity: 0.2,
    stroke: "#FFFFFF",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("text", {
    id: "20%\\u2265\\u8F83\\u5DEE\\u5360\\u6BD4\\uFF1E5%",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20,
    fillOpacity: 0.85
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 23,
    y: 31
  }, "20%\u2265\u8F83\u5DEE\u5360\u6BD4\uFF1E5%"))), /*#__PURE__*/React.createElement("text", {
    id: "No\\u5907\\u4EFD",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20,
    fill: "#E64242"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 56,
    y: 19
  }, "No")), /*#__PURE__*/React.createElement("path", {
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-9",
    d: "M81,-0.5 L81,23.5 L85,23.5 L80.5,32.5 L76,23.5 L80,23.5 L80,-0.5 L81,-0.5 Z",
    fillOpacity: 0.45,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-11\\u5907\\u4EFD-3",
    transform: "translate(96.000000, 556.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-7\\u5907\\u4EFD-28",
    transform: "translate(0.000000, 32.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80,0.529740503 L158.486456,28 L80,55.4702595 L1.51354429,28 L80,0.529740503 Z",
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-23",
    strokeOpacity: 0.2,
    stroke: "#FFFFFF",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("text", {
    id: "5%\\u2265\\u5F02\\u5E38\\u5360\\u6BD4\\uFF1E0%",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20,
    fillOpacity: 0.85
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 26,
    y: 31
  }, "5%\u2265\u5F02\u5E38\u5360\u6BD4\uFF1E0%"))), /*#__PURE__*/React.createElement("text", {
    id: "No\\u5907\\u4EFD",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20,
    fill: "#E64242"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 56,
    y: 19
  }, "No")), /*#__PURE__*/React.createElement("path", {
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-9",
    d: "M81,-0.5 L81,23.5 L85,23.5 L80.5,32.5 L76,23.5 L80,23.5 L80,-0.5 L81,-0.5 Z",
    fillOpacity: 0.45,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-11\\u5907\\u4EFD-2",
    transform: "translate(96.000000, 468.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-7\\u5907\\u4EFD-28",
    transform: "translate(0.000000, 32.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80,0.529740503 L158.486456,28 L80,55.4702595 L1.51354429,28 L80,0.529740503 Z",
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-23",
    strokeOpacity: 0.2,
    stroke: "#FFFFFF",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("text", {
    id: "90%\\u2265\\u4E00\\u822C\\u5360\\u6BD4\\uFF1E70%",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20,
    fillOpacity: 0.85
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 20,
    y: 31
  }, "90%\u2265\u4E00\u822C\u5360\u6BD4\uFF1E70%"))), /*#__PURE__*/React.createElement("text", {
    id: "No\\u5907\\u4EFD",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20,
    fill: "#E64242"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 56,
    y: 19
  }, "No")), /*#__PURE__*/React.createElement("path", {
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-9",
    d: "M81,-0.5 L81,23.5 L85,23.5 L80.5,32.5 L76,23.5 L80,23.5 L80,-0.5 L81,-0.5 Z",
    fillOpacity: 0.45,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-11\\u5907\\u4EFD",
    transform: "translate(96.000000, 380.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-7\\u5907\\u4EFD-28",
    transform: "translate(0.000000, 32.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80,0.529740503 L158.486456,28 L80,55.4702595 L1.51354429,28 L80,0.529740503 Z",
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-23",
    strokeOpacity: 0.2,
    stroke: "#FFFFFF",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("text", {
    id: "50%\\u2265\\u8F83\\u5DEE\\u5360\\u6BD4\\uFF1E20%",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20,
    fillOpacity: 0.85
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 19,
    y: 31
  }, "50%\u2265\u8F83\u5DEE\u5360\u6BD4\uFF1E20%"))), /*#__PURE__*/React.createElement("text", {
    id: "No\\u5907\\u4EFD",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20,
    fill: "#E64242"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 56,
    y: 19
  }, "No")), /*#__PURE__*/React.createElement("path", {
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-9",
    d: "M81,-0.5 L81,23.5 L85,23.5 L80.5,32.5 L76,23.5 L80,23.5 L80,-0.5 L81,-0.5 Z",
    fillOpacity: 0.45,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-11",
    transform: "translate(96.000000, 292.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-7\\u5907\\u4EFD-28",
    transform: "translate(0.000000, 32.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80,0.529740503 L158.486456,28 L80,55.4702595 L1.51354429,28 L80,0.529740503 Z",
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-23",
    strokeOpacity: 0.2,
    stroke: "#FFFFFF",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("text", {
    id: "10%\\u2265\\u5F02\\u5E38\\u5360\\u6BD4\\uFF1E5%",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20,
    fillOpacity: 0.85
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 24,
    y: 31
  }, "10%\u2265\u5F02\u5E38\u5360\u6BD4\uFF1E5%"))), /*#__PURE__*/React.createElement("text", {
    id: "No\\u5907\\u4EFD",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20,
    fill: "#E64242"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 56,
    y: 19
  }, "No")), /*#__PURE__*/React.createElement("path", {
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-9",
    d: "M81,-0.5 L81,23.5 L85,23.5 L80.5,32.5 L76,23.5 L80,23.5 L80,-0.5 L81,-0.5 Z",
    fillOpacity: 0.45,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("text", {
    id: "No",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20,
    fill: "#E64242"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 152,
    y: 223
  }, "No")), /*#__PURE__*/React.createElement("path", {
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD",
    d: "M177,203.5 L177,227.5 L181,227.5 L176.5,236.5 L172,227.5 L176,227.5 L176,203.5 L177,203.5 Z",
    fillOpacity: 0.45,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("text", {
    id: "yes\\u5907\\u4EFD",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20,
    fill: "#52C41A"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 287,
    y: 76
  }, "yes")), /*#__PURE__*/React.createElement("text", {
    id: "yes\\u5907\\u4EFD-2",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20,
    fill: "#52C41A"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 287,
    y: 164
  }, "yes")), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-10\\u5907\\u4EFD-8",
    transform: "translate(256.000000, 943.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "yes\\u5907\\u4EFD-3",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20,
    fill: "#52C41A"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 31,
    y: 13
  }, "yes")), /*#__PURE__*/React.createElement("path", {
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-4",
    d: "M72,20 L81,24.5 L72,29 L72,25 L0,25 L0,24 L72,24 L72,20 Z",
    fillOpacity: 0.45,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-10\\u5907\\u4EFD-7",
    transform: "translate(256.000000, 855.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "yes\\u5907\\u4EFD-3",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20,
    fill: "#52C41A"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 31,
    y: 13
  }, "yes")), /*#__PURE__*/React.createElement("path", {
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-4",
    d: "M72,20 L81,24.5 L72,29 L72,25 L0,25 L0,24 L72,24 L72,20 Z",
    fillOpacity: 0.45,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-10\\u5907\\u4EFD-6",
    transform: "translate(256.000000, 767.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "yes\\u5907\\u4EFD-3",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20,
    fill: "#52C41A"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 31,
    y: 13
  }, "yes")), /*#__PURE__*/React.createElement("path", {
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-4",
    d: "M72,20 L81,24.5 L72,29 L72,25 L0,25 L0,24 L72,24 L72,20 Z",
    fillOpacity: 0.45,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-10\\u5907\\u4EFD-5",
    transform: "translate(256.000000, 679.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "yes\\u5907\\u4EFD-3",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20,
    fill: "#52C41A"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 31,
    y: 13
  }, "yes")), /*#__PURE__*/React.createElement("path", {
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-4",
    d: "M72,20 L81,24.5 L72,29 L72,25 L0,25 L0,24 L72,24 L72,20 Z",
    fillOpacity: 0.45,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-10\\u5907\\u4EFD-4",
    transform: "translate(256.000000, 591.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "yes\\u5907\\u4EFD-3",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20,
    fill: "#52C41A"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 31,
    y: 13
  }, "yes")), /*#__PURE__*/React.createElement("path", {
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-4",
    d: "M72,20 L81,24.5 L72,29 L72,25 L0,25 L0,24 L72,24 L72,20 Z",
    fillOpacity: 0.45,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-10\\u5907\\u4EFD-3",
    transform: "translate(256.000000, 503.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "yes\\u5907\\u4EFD-3",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20,
    fill: "#52C41A"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 31,
    y: 13
  }, "yes")), /*#__PURE__*/React.createElement("path", {
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-4",
    d: "M72,20 L81,24.5 L72,29 L72,25 L0,25 L0,24 L72,24 L72,20 Z",
    fillOpacity: 0.45,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-10\\u5907\\u4EFD-2",
    transform: "translate(256.000000, 415.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "yes\\u5907\\u4EFD-3",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20,
    fill: "#52C41A"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 31,
    y: 13
  }, "yes")), /*#__PURE__*/React.createElement("path", {
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-4",
    d: "M72,20 L81,24.5 L72,29 L72,25 L0,25 L0,24 L72,24 L72,20 Z",
    fillOpacity: 0.45,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-10\\u5907\\u4EFD",
    transform: "translate(256.000000, 327.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "yes\\u5907\\u4EFD-3",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20,
    fill: "#52C41A"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 31,
    y: 13
  }, "yes")), /*#__PURE__*/React.createElement("path", {
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-4",
    d: "M72,20 L81,24.5 L72,29 L72,25 L0,25 L0,24 L72,24 L72,20 Z",
    fillOpacity: 0.45,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-10",
    transform: "translate(256.000000, 239.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "yes\\u5907\\u4EFD-3",
    fontFamily: "PingFangSC-Regular, PingFang SC",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20,
    fill: "#52C41A"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 31,
    y: 13
  }, "yes")), /*#__PURE__*/React.createElement("path", {
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-4",
    d: "M72,20 L81,24.5 L72,29 L72,25 L0,25 L0,24 L72,24 L72,20 Z",
    fillOpacity: 0.45,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u76F4\\u7EBF",
    d: "M177,27.5 L177,51.5 L181,51.5 L176.5,60.5 L172,51.5 L176,51.5 L176,27.5 L177,27.5 Z",
    fillOpacity: 0.45,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-2",
    d: "M328,83 L337,87.5 L328,92 L328,88 L256,88 L256,87 L328,87 L328,83 Z",
    fillOpacity: 0.45,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 456.5,
    y1: 87.5,
    x2: 536.5,
    y2: 87.5,
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-5",
    strokeOpacity: 0.45,
    stroke: "#FFFFFF",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 456.5,
    y1: 967.5,
    x2: 536.5,
    y2: 967.5,
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-17",
    strokeOpacity: 0.45,
    stroke: "#FFFFFF",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 456.5,
    y1: 879.5,
    x2: 536.5,
    y2: 879.5,
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-16",
    strokeOpacity: 0.45,
    stroke: "#FFFFFF",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 456.5,
    y1: 791.5,
    x2: 536.5,
    y2: 791.5,
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-15",
    strokeOpacity: 0.45,
    stroke: "#FFFFFF",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 456.5,
    y1: 703.5,
    x2: 536.5,
    y2: 703.5,
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-14",
    strokeOpacity: 0.45,
    stroke: "#FFFFFF",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 456.5,
    y1: 615.5,
    x2: 536.5,
    y2: 615.5,
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-13",
    strokeOpacity: 0.45,
    stroke: "#FFFFFF",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 456.5,
    y1: 527.5,
    x2: 536.5,
    y2: 527.5,
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-12",
    strokeOpacity: 0.45,
    stroke: "#FFFFFF",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 456.5,
    y1: 439.5,
    x2: 536.5,
    y2: 439.5,
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-11",
    strokeOpacity: 0.45,
    stroke: "#FFFFFF",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 456.5,
    y1: 351.5,
    x2: 536.5,
    y2: 351.5,
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-10",
    strokeOpacity: 0.45,
    stroke: "#FFFFFF",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 456.5,
    y1: 263.5,
    x2: 536.5,
    y2: 263.5,
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-8",
    strokeOpacity: 0.45,
    stroke: "#FFFFFF",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 456.5,
    y1: 175.5,
    x2: 536.5,
    y2: 175.5,
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-6",
    strokeOpacity: 0.45,
    stroke: "#FFFFFF",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u76F4\\u7EBF\\u5907\\u4EFD-3",
    d: "M328,171 L337,175.5 L328,180 L328,176 L256,176 L256,175 L328,175 L328,171 Z",
    fillOpacity: 0.45,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPvDispersionRateConfigFlow);
export default __webpack_public_path__ + "static/media/PvDispersionRateConfigFlow.8de1d3b1abff23994a83110615d30ab9.svg";
export { ForwardRef as ReactComponent };